import { AxiosInstance } from 'axios';

import Company from '@/model/General/Company';
import { PaymentMethod } from '@/model/General/PaymentMethod';

import CompanyApi from './CompanyApi';

class CompanyRepository {
  companyApi: CompanyApi;

  constructor(axiosInstance: AxiosInstance) {
    this.companyApi = new CompanyApi(axiosInstance);
  }

  getCompanyContact(company: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.companyApi
        .getCompanyContact(company)
        .then((data: any) => {
          resolve(data.results);
        })
        .catch(() => {
          console.error('Error al obtener el contacto de la empresa');
          reject();
        });
    });
  }

  updateCompany(company: number, companyData: Partial<Company>): Promise<any> {
    return new Promise((resolve, reject) => {
      this.companyApi
        .updateCompany(company, companyData)
        .then((data: any) => {
          resolve(data.results);
        })
        .catch(() => {
          console.error('Error al actualizar la empresa');
          reject();
        });
    });
  }

  getPaymentMethod(company: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.companyApi
        .getPaymentMethod(company)
        .then((data: any) => {
          resolve(data.results);
        })
        .catch(() => {
          console.error('Error al obtener el método de pago de la empresa');
          reject();
        });
    });
  }

  createPaymentMethod(paymentMethodData: Partial<PaymentMethod>): Promise<void> {
    return new Promise((resolve, reject) => {
      this.companyApi
        .createPaymentMethod(paymentMethodData)
        .then(() => {
          resolve();
        })
        .catch(() => {
          console.error('Error al crear el método de pago de la empresa');
          reject();
        });
    });
  }
}

export default CompanyRepository;
